<template>
  <div id="app">
    <Nav/>
    <router-view/>
  </div>
</template>

<script>
import Nav from './components/Nav.vue';

export default {
  components: {
    Nav,
  },
};
</script>

<style lang="scss">
  @import './styles/main';
  @import './styles/layout';

  body.no-select {
    user-select: none;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }

  canvas {
    display: block;
  }

  .mobile-warning {
    margin: auto;
    padding: 20px;
    line-height: 1.5;
  }
</style>
